export const GRID_PREFERENCE_LOADING = 'GRID_PREFERENCE_LOADING';
export const GRID_PREFERENCE_LIST = 'GRID_PREFERENCE_LIST';
export const GRID_PREFERENCE_IS_SUBMITTING = 'GRID_PREFERENCE_IS_SUBMITTING';
export const GRID_PREFERENCE_LIST_ERROR = 'GRID_PREFERENCE_LIST_ERROR';
export const GRID_PREFERENCE_SAVE_ERROR = 'GRID_PREFERENCE_SAVE_ERROR';
export const GRID_PREFERENCE_SUBMIT = 'GRID_PREFERENCE_SUBMIT';
export const GRID_PREFERENCE_CLEAR_ERROR = 'GRID_PREFERENCE_CLEAR_ERROR';
export const CLEAR_GRID_PREFERENCE = 'CLEAR_GRID_PREFERENCE';



// WEBPACK FOOTER //
// ./src/state/gridPreference/types.js